var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Button, Select } from "semantic-ui-react";
import FieldWithErrorDisplay from "../FieldWithErrorDisplay";
var ChangePoApprovalType = /** @class */ (function (_super) {
    __extends(ChangePoApprovalType, _super);
    function ChangePoApprovalType(props) {
        var _this = _super.call(this, props) || this;
        _this.onTypeChange = function (event, data) {
            var val = data.value;
            if (typeof val !== 'string') {
                throw new Error("Unexpected type value: " + val);
            }
            _this.setState({
                poApprovalType: val
            });
        };
        _this.submit = function () {
            _this.props.postRequest("/admin/orders/id/" + encodeURIComponent(_this.props.orderId) + "/po-approval-type", {
                poApprovalType: _this.state.poApprovalType
            });
        };
        _this.state = {
            poApprovalType: props.currentPoApprovalType
        };
        return _this;
    }
    ChangePoApprovalType.prototype.render = function () {
        return React.createElement(React.Fragment, null,
            React.createElement(FieldWithErrorDisplay, { errorPath: '/poApprovalType', errors: this.props.state.errors, required: true, labelContent: 'PO approval type' },
                React.createElement(Select, { options: this.props.poApprovalTypes.map(function (t) { return ({
                        value: t,
                        text: t
                    }); }), value: this.state.poApprovalType, onChange: this.onTypeChange })),
            React.createElement(Button, { disabled: this.props.state.loading
                    || this.props.state.success
                    || this.state.poApprovalType === this.props.currentPoApprovalType, icon: 'edit', label: 'Change approval type', labelPosition: 'left', onClick: this.submit, positive: true }));
    };
    return ChangePoApprovalType;
}(React.PureComponent));
export default ChangePoApprovalType;
//# sourceMappingURL=ChangePoApprovalType.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/admin/ChangePoApprovalType.js
// module id = 1181
// module chunks = 0